import { attrsRecordInternalToRaw } from "src/business/attribute/values/attrValueInternalToRaw";
import {
  ZUnsafeValues,
  zUnsafeValues,
} from "src/business/attribute/ZAttrValue";
import { ZCatalogRecordToSave } from "src/business/records/ZCatalogRecord";
import { ZSpecification } from "src/business/specification";
import { catalogRecordSystemKeys } from "src/common/systemKey";

import { zClassificationInternal } from "./ZClassificationInternal";

export const makeRecordDataToSave = (
  srcData: unknown,
  schemes: ZSpecification[],
): ZCatalogRecordToSave => {
  const result: ZCatalogRecordToSave = {
    data: {},
    classification: [],
  };
  const unsafeSrcData = zUnsafeValues.parse(srcData);
  schemes.forEach((scheme) => {
    const part = unsafeSrcData[scheme.name];
    const attributes = scheme.definition?.attributes;
    if (part && typeof part === "object" && attributes) {
      result.data[scheme.name] = attrsRecordInternalToRaw(
        part as ZUnsafeValues,
        attributes,
      );
    }
  });
  const clsMap = zClassificationInternal.safeParse(
    unsafeSrcData[catalogRecordSystemKeys.classification],
  );
  if (clsMap.success) {
    Object.entries(clsMap.data).forEach(([classifierId, classes]) => {
      result.classification.push({
        classifierId,
        classIds: classes?.map(({ id }) => id) ?? [],
      });
    });
  }
  return result;
};
